import { render, staticRenderFns } from "./CIDSubmissionsTab.vue?vue&type=template&id=45c9fb69&scoped=true"
import script from "./CIDSubmissionsTab.vue?vue&type=script&lang=js"
export * from "./CIDSubmissionsTab.vue?vue&type=script&lang=js"
import style0 from "./CIDSubmissionsTab.vue?vue&type=style&index=0&id=45c9fb69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c9fb69",
  null
  
)

export default component.exports